module.exports = "https://static.zego.com/_next/static/images/BI-f301d64262fb835cf7017b4cc97f41d3.svg";